export function formatDate(
  date: string,
  options: Intl.DateTimeFormatOptions = {}
) {
  return new Intl.DateTimeFormat(navigator.language, options).format(
    new Date(date)
  );
}
